import { GET_ORG_SETTINGS, UPDATE_ORG_SETTINGS } from '../../types'

const initialState = {
  general: {
    defaultAUP: '',
    aupName: '',
    authenticationMethod: '',
    disableAgents: 0,
    enableWebLog: 0,
    enableSMS: 0,
    enableLSAlerts: 1
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORG_SETTINGS: return {
      ...state,
      general: action.payload
    }
    case UPDATE_ORG_SETTINGS: return {
      ...state,
      general: action.payload
    }
    default: return { ...state }
  }
}
